import React, { useState } from "react";
import { post } from "helpers/api_helper";
import { useEffect } from "react";
import { toImageUrl } from "helpers/file_upload_helper";
import { Label, Row } from "reactstrap";
import Loader from "./loader";
import toastr from "toastr";

const MAX_UPLOAD_MB = 20;

// Saved images may be a JSON array of paths or of {path} objects; anything else means none.
const toPaths = (files) => Array.isArray(files) ? files.map(f => typeof f === 'string' ? f : f?.path).filter(Boolean) : [];

const UploadImages = props => {

    const [loading, setLoading] = useState(false);
    const [files, setFiles] = useState([]);
    const [InputLabel, setInputLabel] = useState('');
    const [InputWidth, setInputWidth] = useState('4');
    const [type, setType] = useState('');

    useEffect(() => {
        if (props.state) {
            setType(props.state.type);
            setFiles(toPaths(props.state.files));
            setInputLabel(props.state.InputLabel);
            setInputWidth(props.state.InputWidth);
        }
    }, []);

    const handleFileUpload = (event) => {
        const imagefiles = Array.from(event.target.files);
        if (imagefiles.some(file => file.size > MAX_UPLOAD_MB * 1024 * 1024)) {
            toastr.error(`File too large (max ${MAX_UPLOAD_MB} MB)`);
            event.target.value = '';
            return;
        }
        setLoading(true);
        // The backend multer middleware only accepts the "file" field.
        Promise.all(imagefiles.map((file) =>
            post('general/upload-image', { file, type }, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then((response) => {
                    const path = response.data.path;
                    setFiles(prev => [...prev, path]);
                })
                .catch((error) => {
                    toastr.error(error?.response?.data?.message || 'Upload failed');
                })
        )).finally(() => {
            setLoading(false);
            event.target.value = '';
        });
    }

    return (
        <div className={`form-group col-md-${InputWidth} mt-2`}>
            <Label className="form-label">{InputLabel}</Label>
            <input className="form-control" type="file" onChange={handleFileUpload} multiple />
            <input type="hidden" name="imagePaths" id="imagePaths" value={JSON.stringify(files)}></input>
            <br></br>
            {loading ? <Loader></Loader> : null}
            <Row>
                {files.map((file, index) => (<img style={{ width: "100px", background: "#f5f5f5", padding: "5px", marginRight: "5px" }} key={index} src={toImageUrl(file)}></img>))}
            </Row>
        </div >
    );
}

export default UploadImages;
